<!-- <div class="flex-center" *ngIf="loading">
  <mat-spinner diameter="50"></mat-spinner>
</div> -->

<div class="backdrop" *ngIf="loading" [style.display]="loading?'block':'none'">
  <div class="flex-center loading">
    <mat-spinner color="accent" diameter="50"></mat-spinner>
  </div>
</div>
